import { OpenedDialogs, notifyOfBackdropChange } from './helpers';
import { closest } from '../../utils/domHelpers';
import { AhaDialog } from './aha-dialog';

/**
 * -----------------------------------
 * ----- Listen for scrolling and adjust relatively positioned dialogs.
 * ------------------------------------
 */
function handleScroll(e: Event) {
  if (!OpenedDialogs.size) return;

  requestAnimationFrame(() => {
    OpenedDialogs.forEach((dialogElem: HTMLAhaDialogElement) => {
      // @ts-ignore
      if (dialogElem.open && dialogElem.isRelativelyPositioned) {
        dialogElem.reposition();
      }
    });
  });
}
window.addEventListener('scroll', handleScroll);

/**
 * -----------------------------------
 * ----- Reposition relatively positioned dialogs when the window is resized.
 * ------------------------------------
 */
function handleResize(e: Event) {
  OpenedDialogs.forEach((dialogElem: HTMLAhaDialogElement) => {
    // @ts-ignore
    if (dialogElem.open && dialogElem.isRelativelyPositioned) dialogElem.reposition();
  });
}
window.addEventListener('resize', handleResize);

/**
 * -----------------------------------
 * ----- Handle automatically hiding dialogs when their "inner" content or `positionTarget` are moused off of.
 * ------------------------------------
 */

// There can be multiple open dialogs whose timers we need to track.
let pointerOutsideTimers = new WeakMap();

function clearpointerOutsideTimers(dialog: AhaDialog) {
  const timer = pointerOutsideTimers.get(dialog.host);
  if (timer) {
    clearTimeout(timer);
    pointerOutsideTimers.delete(dialog.host);
  }
}

function handlePointerOutside(event: any) {
  const dialog = event.detail;
  // If the dialog is not open, or it has a backdrop, or it is persistent, or it is not set to `hideWhenOutside`, then do nothing.
  if (!dialog.open || !dialog.hideBackdrop || dialog.persistent || !dialog.hideWhenOutside) {
    clearpointerOutsideTimers(dialog);
    return;
  }

  const timer = pointerOutsideTimers.get(dialog.host);
  if (!timer) {
    const t = setTimeout(() => {
      dialog.hide(true);
    }, 250);
    pointerOutsideTimers.set(dialog.host, t);
  }
}
window.addEventListener('aha-dialog:pointer-outside', handlePointerOutside);

function handlePointerInside(event: any) {
  const dialog = event.detail;
  clearpointerOutsideTimers(dialog);
}
window.addEventListener('aha-dialog:pointer-inside', handlePointerInside);
